<template>
<div class="chapter">
<div class="inner_page">
<p class="sp"> </p>
<p class="fmh"><span class="epub-b">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#cpyntc" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><span href="#/xhtml/dedication#ded" title="Link target outside of Sample">Dedication</span></p>
<p class="toc"><span href="#/xhtml/epigraph#epi" title="Link target outside of Sample">Epigraphs</span></p>
<p class="toc-1"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><a href="#/xhtml/newyrkprod#newyrk">Production information (New York production)</a></p>
<p class="toc"><a href="#/xhtml/londprod#lndon">Production information (London production)</a></p>
<p class="toc"><a href="#/xhtml/castlist#cast">Cast list</a></p>
<p class="toc-1"><a href="#/xhtml/play#play">Play</a></p>
<p class="toc"><span href="#/xhtml/aboutauthor#abt" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#cpy" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?a9db60a4